<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import themeConfig from '@/../themeConfig.js'

  export default {
    name: 'app',
    components: {},
    data: () => ({}),
    watch: {
      '$store.state.theme'(val) {
        this.toggleBodyClass(val);
      }
    },
    methods: {
      toggleBodyClass(className) {
        if (className == 'dark') {
          document.body.classList.add('dark-theme');
        } else {
          document.body.classList.remove('dark-theme');

        }
      }
    },

    mounted() {
      this.toggleBodyClass(themeConfig.theme)
    },
  }


</script>

<style rel="stylesheet/scss" lang="scss">
  .el-drawer__body {
    overflow: auto;
  }
  .el-drawer__container ::-webkit-scrollbar{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue